import React from 'react';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import * as actions from '../../address/actions';
import Address from '../../address';
import { isMobileDevice, scrollToTop } from 'shared/utils';

class LandingPageAddress extends Address {

  componentDidMount() {
    const id = this.props.customId || this.inputEle;
    this.autocomplete = new google.maps.places.Autocomplete((document.getElementById(id)), {types: ['geocode']});
    this.autocomplete.addListener('place_changed', () => {
      this.fillInAddress();
      scrollToTop();
    });
    this.geolocate();
    this.geocoder = new google.maps.Geocoder();
  }

  geolocate() { /* noop */ }

  scrollToTop() {
    if (this.isSmallMobileDevice()) {
      scrollIntoView(this.input, { align: { top: 0, topOffset: 55 } });
    }
  }

  isSmallMobileDevice() {
    return isMobileDevice() && window.innerWidth < 750;
  }

  render() {
    const id = this.props.customId || this.inputEle;
    return (
      <form className="cta-form" onSubmit={this.handleSubmit}>
        <input
          type="text"
          id={id}
          className="form-control cta-form__input"
          placeholder="Enter ZIP Code or Address"
          ref={this.inputRef}
          onFocus={() => this.scrollToTop()}
        />
        <button className="btn-primary green cta-form__btn" type="submit">
          <span className="hidden-md">Submit</span>
          <span className="visible-md-inline">Get Started</span>
        </button>
      </form>
    );
  }
}

function mapStateToProps() {
  return {}
}

export default connect(mapStateToProps, actions)(LandingPageAddress);



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/address.js